"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LANG_ZHCN_TRANS = {
    'time picker': '时间',
    'today': '今天',
    'set time': '设置时间',
    'close': '关闭',
    'confirm': '确认',
    'hour': '时',
    'minute': '分',
    'second': '秒',
};
//# sourceMappingURL=zh-cn.js.map


//////////////////
// WEBPACK FOOTER
// /opt/app/develop/~/ng2-date-time-picker/locale/zh-cn.js
// module id = ../../../../ng2-date-time-picker/locale/zh-cn.js
// module chunks = 4